import dataList from './dataList.vue'

const data = {
  install: function (Vue) {
    Vue.component('dataList', dataList)
  }
}
export default data
